import { GameState } from '../App'
import {
  DEFAULT_POINTS_TO_WIN,
  DEFAULT_SECONDS_PER_TURN
} from '../constants/settings'

const gameStateKey = 'gameState'

export const saveGameStateToLocalStorage = (gameState: GameState) => {
  localStorage.setItem(gameStateKey, JSON.stringify(gameState))
}

export const loadGameStateFromLocalStorage = () => {
  const state = localStorage.getItem(gameStateKey)
  return state ? (JSON.parse(state) as GameState) : null
}

const gameStatKey = 'gameStats'

export type GameStats = {
  totalGames: number
  wins: number[]
  guessDistribution: number[]
  currentStreak: number
  currentStreakPlayer: number
  bestStreak: number,
  bestStreakPlayer: number
}

export const saveStatsToLocalStorage = (gameStats: GameStats) => {
  localStorage.setItem(gameStatKey, JSON.stringify(gameStats))
}

export const loadStatsFromLocalStorage = () => {
  const stats = localStorage.getItem(gameStatKey)
  return stats ? (JSON.parse(stats) as GameStats) : null
}

export type Settings = {
  highContrast: boolean
  tutorialMessages: boolean
  showTimerNumbers: boolean
  pointsToWin: number
  secondsPerTurn: number
}

const defaultSettings : Settings = {
  highContrast: false,
  tutorialMessages: true,
  showTimerNumbers: true,
  pointsToWin: DEFAULT_POINTS_TO_WIN,
  secondsPerTurn: DEFAULT_SECONDS_PER_TURN
}

const settingsKey = 'settings'

export const saveSettingsToLocalStorage = (settings: Settings) => {
  localStorage.setItem(settingsKey, JSON.stringify(settings))
}

export const loadSettingsFromLocalStorage = () => {
  const settings = localStorage.getItem(settingsKey)
  return settings ? (JSON.parse(settings) as Settings) : defaultSettings
}

const nextSolutionIndexKey = 'nextSolutionIndex'

export const setStoredNextSolutionIndex = (nextSolutionIndex: number) => {
    localStorage.setItem(nextSolutionIndexKey, JSON.stringify(nextSolutionIndex));
}

export const getStoredNextSolutionIndex = () => {
  const index = localStorage.getItem(nextSolutionIndexKey)
  return index ? (JSON.parse(index) as number) : 0
}

const shuffledSolutionsKey = 'shuffledSolutions'

export const setStoredShuffledSolutions = (solutions: string[]) => {
    localStorage.setItem(shuffledSolutionsKey, JSON.stringify(solutions));
}

export const getStoredShuffledSolutions = () => {
  const solutions = localStorage.getItem(shuffledSolutionsKey)
  return solutions ? (JSON.parse(solutions) as string[]) : []
}

const startPlayerKey = 'startPlayer'

export const setStoredStartPlayer = (startPlayer: number) => {
    localStorage.setItem(startPlayerKey, JSON.stringify(startPlayer));
}

export const getStoredStartPlayer = () => {
  const startPlayer = localStorage.getItem(startPlayerKey)
  return startPlayer ? (JSON.parse(startPlayer) as number) : 0
}

